import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IPollGeneral } from '../../../../models/poll.model';
import { IClientConfig } from '../../../../models/client.model';

@Component({
  selector: 'app-event-poll-message',
  templateUrl: 'event-poll-message.html'
})

export class EventPollMessageComponent implements OnInit {

  @Input('general') public general: IPollGeneral;
  @Input('language') public language: string;
  @Output('changeView') public changeView: EventEmitter<boolean> = new EventEmitter();

  @Input('clientConfig')
  public clientConfig: any;

  constructor() { }

  ngOnInit() { }

  public changeToQuestions() {
    this.changeView.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/poll-event/components/event-poll-message/event-poll-message.ts